export const WSCommands = {
  tripMonitor: "trip-monitor.trip",
  message: "message",
  messages: "messages",
  threads: "threads",
  thread: "thread",
  tripMonitorRoute: "trip-monitor.route",
  tripTruck: "trip-monitor.truck",
  order: "order",
  trip: "trip",
  truckReserved: "truck.reserved",
};
